import React, { Fragment } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons'
import '../../../../../styles/balanco.scss'

const Componente = (props) => {

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchComponentes()
    }

    const editar = async (id) => {
        props.editar(id)
    }
    return (
        <Fragment>
            <tr>
                <td data-label="Nome">{props.componente.nome}</td>
                <td data-label="Categoria">{props.componente.categoria}</td>
                <td data-label="Tipo">{props.componente.tipo}</td>
                <td data-label="Descrição">{props.componente.descricao}</td>

                {/* ---- CÉLULAS PARA DESKTOP (cada ação tem seu td) ---- */}
                <td className="acoes-desktop-cell" title="Editar" style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faPenToSquare}
                        className="mx-2 text-warning cursor-pointer"
                        onClick={() => editar(props.componente._id)}
                    />
                </td>

                <td className="acoes-desktop-cell" title="Excluir" style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faTrash}
                        className="mx-2 text-danger cursor-pointer"
                        onClick={() => deletar(props.componente._id)}
                    />
                </td>

                {/* ---- CÉLULA EXTRA: GRID DE AÇÕES APENAS PARA MOBILE ----
                     Esta célula fica no DOM sempre, mas será escondida no desktop.
                     No mobile mostramos ela e escondemos as acoes-desktop-cell. */}
                <td className="acoes-mobile-cell">
                    <div className="acoes-mobile">
                        <div className="acao-item" onClick={() => editar(props.componente._id)}>
                            <FontAwesomeIcon icon={faPenToSquare} className="acao-icon text-warning" />
                            <span>Editar</span>
                        </div>
                        <div className="acao-item" onClick={() => deletar(props.componente._id)}>
                            <FontAwesomeIcon icon={faTrash} className="acao-icon text-danger" />
                            <span>Excluir</span>
                        </div>
                    </div>
                </td>
            </tr>
        </Fragment>
    )
}

export default Componente;
